(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-toast"] && !Shopify.designMode) return;
  try {
    (function () {
    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;

    var img = toast.querySelector('[data-toast-img]');
    var nameEl = toast.querySelector('[data-toast-name]');
    var closeBtn = toast.querySelector('[data-toast-close]');
    var viewBtn = toast.querySelector('[data-toast-view]');
    var progress = toast.querySelector('[data-toast-progress]');

    function sized(url) {
      if (!url) return '';
      return url.replace(/(\.(?:jpe?g|png|webp|gif))(\?.*)?$/i, '_96x96_crop_center$1$2');
    }

    function hide() {
      toast.classList.remove('is-visible', 'is-counting');
      toast.setAttribute('aria-hidden', 'true');
    }

    function show(item) {
      if (item) {
        nameEl.textContent = item.product_title || item.title || 'Item';
        var src = item.image || (item.featured_image && item.featured_image.url);
        if (src) { img.src = sized(src); img.hidden = false; }
        else { img.hidden = true; }
      }
      toast.hidden = false;
      toast.setAttribute('aria-hidden', 'false');
      /* Restart the timer animation on repeat adds */
      toast.classList.remove('is-counting');
      void toast.offsetWidth;
      requestAnimationFrame(function () {
        toast.classList.add('is-visible', 'is-counting');
      });
    }

    document.addEventListener('cart:added', function (e) {
      show(e.detail && e.detail.item);
    });

    /* The timer bar finishing = auto-dismiss (paused while hovered/focused) */
    progress.addEventListener('animationend', hide);

    closeBtn.addEventListener('click', hide);
    viewBtn.addEventListener('click', function () {
      hide();
      document.dispatchEvent(new CustomEvent('cart:open'));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function() {
    var SELECTORS = {
      overlay: '#predictive-search',
      input: '[data-predictive-input]',
      results: '[data-search-results]',
      loading: '[data-search-loading]',
      clear: '[data-search-clear]',
      close: '[data-search-close]',
      status: '[data-search-status]',
      trigger: '[data-search-trigger]'
    };

    var DEBOUNCE_MS = 300;
    var MIN_CHARS = 2;
    var PRODUCT_LIMIT = 6;

    var overlay, input, resultsEl, loadingEl, clearBtn, statusEl;
    var searchUrl = '/search';
    var debounceTimer = null;
    var triggerElement = null;
    var abortController = null;

    function init() {
      overlay   = document.querySelector(SELECTORS.overlay);
      input     = document.querySelector(SELECTORS.input);
      resultsEl = document.querySelector(SELECTORS.results);
      loadingEl = document.querySelector(SELECTORS.loading);
      clearBtn  = document.querySelector(SELECTORS.clear);
      statusEl  = document.querySelector(SELECTORS.status);

      if (!overlay || !input) return;

      /* Resolve the localized search URL from the form action (multi-market safe) */
      var form = overlay.querySelector('.predictive-search__form');
      if (form && form.getAttribute('action')) {
        searchUrl = form.getAttribute('action');
      }

      /* Trap keyboard focus within the overlay while it is open */
      overlay.addEventListener('keydown', trapFocus);

      /* Search trigger (header icon) */
      document.querySelectorAll(SELECTORS.trigger).forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          triggerElement = btn;
          open();
        });
      });

      /* Input events */
      input.addEventListener('input', handleInput);
      input.addEventListener('keydown', handleKeydown);

      /* Clear button */
      if (clearBtn) {
        clearBtn.addEventListener('click', function() {
          input.value = '';
          clearBtn.hidden = true;
          resultsEl.innerHTML = '';
          input.setAttribute('aria-expanded', 'false');
          input.focus();
          announce('Search cleared');
        });
      }

      /* Close button */
      var closeBtn = document.querySelector(SELECTORS.close);
      if (closeBtn) {
        closeBtn.addEventListener('click', close);
      }

      /* Backdrop click (body::after scrim) */
      document.addEventListener('click', function(e) {
        if (isOpen() && e.target === document.body) {
          close();
        }
      });

      /* Escape key */
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isOpen()) {
          close();
        }
      });
    }

    function isOpen() {
      return overlay && overlay.classList.contains('is-open');
    }

    function trapFocus(e) {
      if (e.key !== 'Tab' || !isOpen()) return;

      var selector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
      var focusable = Array.prototype.filter.call(
        overlay.querySelectorAll(selector),
        function(el) { return !el.hidden && el.offsetParent !== null; }
      );
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      overlay.hidden = false;

      /* Entry transition handled in CSS via @starting-style — no JS reflow. */
      overlay.classList.add('is-open');
      document.body.classList.add('search-open');

      /* Focus input */
      input.focus();
    }

    function close() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('search-open');

      /* Cancel any pending requests */
      if (abortController) {
        abortController.abort();
        abortController = null;
      }

      /* Hide after transition */
      var onEnd = function() {
        if (!isOpen()) {
          overlay.hidden = true;
        }
        overlay.removeEventListener('transitionend', onEnd);
      };
      overlay.addEventListener('transitionend', onEnd);

      /* Fallback for prefers-reduced-motion */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        overlay.hidden = true;
      }

      /* Return focus to trigger */
      if (triggerElement) {
        triggerElement.focus();
        triggerElement = null;
      }
    }

    function handleInput() {
      var query = input.value.trim();

      /* Toggle clear button */
      if (clearBtn) {
        clearBtn.hidden = query.length === 0;
      }

      if (query.length < MIN_CHARS) {
        resultsEl.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
        loadingEl.hidden = true;
        return;
      }

      /* Debounce */
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        fetchResults(query);
      }, DEBOUNCE_MS);
    }

    function handleKeydown(e) {
      /* Arrow key navigation through results */
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var firstItem = resultsEl.querySelector('[data-ps-result]');
        if (firstItem) firstItem.focus();
      }
    }

    function fetchResults(query) {
      /* Cancel previous request */
      if (abortController) abortController.abort();
      abortController = new AbortController();

      loadingEl.hidden = false;
      announce('Searching for ' + query);

      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
                '&resources[type]=product,collection,page,article' +
                '&resources[limit]=' + PRODUCT_LIMIT +
                '&resources[options][unavailable_products]=last';

      fetch(url, { signal: abortController.signal })
        .then(function(res) {
          var contentType = res.headers.get('content-type') || '';
          if (!res.ok || contentType.indexOf('application/json') === -1) {
            /* A non-JSON response (e.g. the store password page) means the
               predictive search endpoint isn't serving results — usually a
               password-protected / unpublished storefront, or a store whose
               search index isn't provisioned yet. Fail loudly, don't SyntaxError. */
            throw new Error(
              'suggest.json returned ' + res.status + ' (' + (contentType || 'no content-type') +
              '). Predictive search is likely unavailable because the storefront is ' +
              'password-protected/unpublished or its search index is not ready.'
            );
          }
          return res.json();
        })
        .then(function(data) {
          loadingEl.hidden = true;
          renderResults(data, query);
        })
        .catch(function(err) {
          if (err.name === 'AbortError') return;
          loadingEl.hidden = true;
          resultsEl.textContent = '';
          console.warn('[Predictive Search]', err.message || err);
        });
    }

    function renderResults(data, query) {
      var resources = data.resources || {};
      var results = resources.results || {};
      var html = '';
      var totalCount = 0;

      /* Products — apparel-style card grid */
      var products = results.products || [];
      if (products.length > 0) {
        totalCount += products.length;
        html += '<div class="predictive-search__group">';
        html += '<p class="predictive-search__group-title">Products</p>';
        html += '<div class="predictive-search__product-grid">';
        products.forEach(function(product) {
          var image = product.image || '';
          var price = formatMoney(product.price);
          var handle = extractHandle(product.url);
          html += '<article class="predictive-search__card">';
          html += '<a href="' + product.url + '" class="predictive-search__card-link" role="option" data-ps-result>';
          html += '<span class="predictive-search__card-media">';
          if (image) {
            html += '<img src="' + getSizedImage(image, '400x') + '" alt="" class="predictive-search__card-image" loading="lazy">';
          }
          html += '</span>';
          html += '<span class="predictive-search__card-body">';
          html += '<span class="predictive-search__card-title">' + highlightMatch(product.title, query) + '</span>';
          html += '<span class="predictive-search__card-price">' + price + '</span>';
          html += '</span>';
          html += '</a>';
          if (handle) {
            html += '<button type="button" class="predictive-search__quick-add" data-quick-add-trigger data-product-handle="' + handle + '" data-product-url="' + product.url + '" aria-label="Quick add ' + escapeHtml(product.title) + '">';
            html += '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4.5v15m7.5-7.5h-15"/></svg>';
            html += '</button>';
          }
          html += '</article>';
        });
        html += '</div>';
        html += '</div>';
      }

      /* Collections */
      var collections = results.collections || [];
      if (collections.length > 0) {
        totalCount += collections.length;
        html += '<div class="predictive-search__group">';
        html += '<p class="predictive-search__group-title">Collections</p>';
        collections.forEach(function(collection) {
          html += '<a href="' + collection.url + '" class="predictive-search__item" role="option" data-ps-result>';
          html += '<div class="predictive-search__item-info">';
          html += '<p class="predictive-search__item-title">' + highlightMatch(collection.title, query) + '</p>';
          html += '</div></a>';
        });
        html += '</div>';
      }

      /* Pages */
      var pages = results.pages || [];
      if (pages.length > 0) {
        totalCount += pages.length;
        html += '<div class="predictive-search__group">';
        html += '<p class="predictive-search__group-title">Pages</p>';
        pages.forEach(function(page) {
          html += '<a href="' + page.url + '" class="predictive-search__item" role="option" data-ps-result>';
          html += '<div class="predictive-search__item-info">';
          html += '<p class="predictive-search__item-title">' + highlightMatch(page.title, query) + '</p>';
          html += '</div></a>';
        });
        html += '</div>';
      }

      /* Articles */
      var articles = results.articles || [];
      if (articles.length > 0) {
        totalCount += articles.length;
        html += '<div class="predictive-search__group">';
        html += '<p class="predictive-search__group-title">Articles</p>';
        articles.forEach(function(article) {
          html += '<a href="' + article.url + '" class="predictive-search__item" role="option" data-ps-result>';
          html += '<div class="predictive-search__item-info">';
          html += '<p class="predictive-search__item-title">' + highlightMatch(article.title, query) + '</p>';
          html += '</div></a>';
        });
        html += '</div>';
      }

      /* No results */
      if (totalCount === 0) {
        html = '<p class="predictive-search__no-results">No results for \u201c' + escapeHtml(query) + '\u201d</p>';
        announce('No results found for ' + query);
      } else {
        /* View all link */
        html += '<a href="' + searchUrl + '?q=' + encodeURIComponent(query) + '" class="predictive-search__view-all">';
        html += 'View all results';
        html += '</a>';
        announce(totalCount + ' results found for ' + query);
      }

      resultsEl.innerHTML = html;
      input.setAttribute('aria-expanded', totalCount > 0 ? 'true' : 'false');

      /* Arrow key navigation within results */
      var items = resultsEl.querySelectorAll('[data-ps-result]');
      items.forEach(function(item, index) {
        item.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            var next = items[index + 1];
            if (next) next.focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (index === 0) {
              input.focus();
            } else {
              items[index - 1].focus();
            }
          }
        });
      });
    }

    /* --- Helpers --- */

    function formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      var amount = (cents / 100).toFixed(2);
      return 'R ' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function getSizedImage(url, size) {
      if (!url) return '';
      /* Shopify image URL sizing: append _96x96 before extension */
      return url.replace(/\.(jpg|jpeg|png|gif|webp)/, '_' + size + '.$1');
    }

    function highlightMatch(text, query) {
      if (!query) return escapeHtml(text);
      var escaped = escapeHtml(text);
      var regex = new RegExp('(' + escapeRegex(query) + ')', 'gi');
      return escaped.replace(regex, '<strong>$1</strong>');
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function extractHandle(url) {
      if (!url) return '';
      /* Extract handle from URLs like /products/my-product or /products/my-product?variant=123 */
      var match = url.match(/\/products\/([^?#\/]+)/);
      return match ? match[1] : '';
    }

    function announce(message) {
      if (statusEl) statusEl.textContent = message;
    }

    /* Boot */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* ===== Quick-Add AJAX ===== */
  (function() {
    /* Use event delegation — product cards render many times per page */
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('form.product-card__quick-add');
      if (!form) return;

      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;

      /* Icon-only button: show loading via aria-busy (CSS dims it), keep the icon */
      btn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
      .then(function(res) {
        if (!res.ok) {
          /* Shopify returns 422 (with a JSON error body) when the item can't be
             added — e.g. sold out or over the stock limit. Treat as a failure. */
          return res.json().then(function(data) {
            throw new Error((data && data.description) || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function(item) {
        btn.removeAttribute('aria-busy');
        /* Notify: refreshes the cart badge + shows the "added to bag" toast */
        document.dispatchEvent(new CustomEvent('cart:added', {
          detail: { item: item, trigger: btn }
        }));
      })
      .catch(function() {
        btn.removeAttribute('aria-busy');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-sheet"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /* -------------------------------------------------------
     * Quick-add bottom sheet — multi-variant product quick-add
     * ------------------------------------------------------- */

    var SELECTORS = {
      sheet: '#quick-add-sheet',
      body: '[data-quick-add-body]',
      loading: '[data-quick-add-loading]',
      status: '[data-quick-add-status]',
      close: '[data-quick-add-close]',
      trigger: '[data-quick-add-trigger]',
      form: '[data-quick-add-form]',
      variantId: '[data-quick-add-variant-id]',
      submitBtn: '[data-quick-add-submit]',
      priceEl: '[data-quick-add-price]'
    };

    var sheet = document.querySelector(SELECTORS.sheet);
    if (!sheet) return;

    var panel = sheet.querySelector('.quick-add-sheet__panel');
    var bodyEl = sheet.querySelector(SELECTORS.body);
    var loadingEl = sheet.querySelector(SELECTORS.loading);
    var statusEl = sheet.querySelector(SELECTORS.status);

    var productCache = {};
    var currentProduct = null;
    var triggerElement = null;
    var isOpen = false;
    /* Monotonic token so a slow fetch for an earlier product can't overwrite
       the sheet after the shopper has opened a different one. */
    var requestToken = 0;

    /* ---------- Helpers ---------- */

    function formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      var amount = (cents / 100).toFixed(2);
      return 'R\u00a0' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function getSizedImageUrl(url, size) {
      if (!url) return '';
      return url.replace(/(\.[a-z]+)(\?.*)?(#.*)?$/i, '_' + size + '$1$2$3');
    }

    function isColorOption(name) {
      return /colou?r/i.test(name);
    }

    /**
     * Normalise product options into a consistent format:
     * [{ name: 'Color', values: ['Red', 'Blue'] }, ...]
     *
     * Shopify's /products/{handle}.js returns:
     * - `options`: array of strings (option names)
     * - `options_with_values`: array of objects (if available)
     * This function prefers `options_with_values` and falls back to
     * deriving values from variant option1/option2/option3 fields.
     */
    function normaliseOptions(product) {
      /* Prefer options_with_values if present */
      if (product.options_with_values && product.options_with_values.length > 0) {
        return product.options_with_values;
      }

      /* Derive from options (string array) + variants */
      var optionNames = product.options || [];
      if (!Array.isArray(optionNames) || optionNames.length === 0) return [];

      /* If options are already objects (e.g. from .json endpoint), use directly */
      if (typeof optionNames[0] === 'object' && optionNames[0].name) {
        return optionNames;
      }

      /* Build from string names + variant values */
      return optionNames.map(function (name, index) {
        var key = 'option' + (index + 1);
        var seen = {};
        var values = [];
        (product.variants || []).forEach(function (v) {
          var val = v[key];
          if (val && !seen[val]) {
            seen[val] = true;
            values.push(val);
          }
        });
        return { name: name, values: values };
      });
    }

    function announce(message) {
      if (statusEl) statusEl.textContent = message;
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    /* ---------- Product fetching ---------- */

    function fetchProduct(handle) {
      if (productCache[handle]) {
        return Promise.resolve(productCache[handle]);
      }

      return fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Product not found');
          return res.json();
        })
        .then(function (product) {
          productCache[handle] = product;
          return product;
        });
    }

    /* ---------- Preload on hover ---------- */

    document.addEventListener('pointerover', function (e) {
      if (!(e.target instanceof Element)) return;
      var trigger = e.target.closest(SELECTORS.trigger);
      if (!trigger) return;

      var handle = trigger.getAttribute('data-product-handle');
      if (!handle || productCache[handle]) return;

      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(function () { fetchProduct(handle); });
      } else {
        fetchProduct(handle);
      }
    }, true);

    /* ---------- Rendering ---------- */

    function getFirstAvailableVariant(product) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) return product.variants[i];
      }
      return product.variants[0];
    }

    function findVariant(product, selectedOptions) {
      return product.variants.find(function (v) {
        var match = true;
        if (selectedOptions[0] !== undefined && v.option1 !== selectedOptions[0]) match = false;
        if (selectedOptions[1] !== undefined && v.option2 !== selectedOptions[1]) match = false;
        if (selectedOptions[2] !== undefined && v.option3 !== selectedOptions[2]) match = false;
        return match;
      }) || null;
    }

    function isValueAvailable(product, optionIndex, value, selectedOptions) {
      var testOptions = selectedOptions.slice();
      testOptions[optionIndex] = value;

      return product.variants.some(function (v) {
        var match = true;
        for (var i = 0; i < testOptions.length; i++) {
          if (testOptions[i] !== undefined) {
            var optionKey = 'option' + (i + 1);
            if (v[optionKey] !== testOptions[i]) {
              match = false;
              break;
            }
          }
        }
        return match && v.available;
      });
    }

    function buildPriceHtml(variant) {
      if (!variant) return '<span class="price">—</span>';

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        return '<span class="price price--sale">' + formatMoney(variant.price) + '</span>' +
               '<span class="price price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
      }

      return '<span class="price">' + formatMoney(variant.price) + '</span>';
    }

    function renderProduct(product) {
      currentProduct = product;

      var firstVariant = getFirstAvailableVariant(product);
      var imageUrl = product.featured_image
        ? getSizedImageUrl(product.featured_image, '240x320_crop_center')
        : '';

      var html = '';

      /* Product header */
      html += '<div class="quick-add-sheet__product">';
      if (imageUrl) {
        html += '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(product.title) + '" class="quick-add-sheet__image" width="80" height="107" loading="eager">';
      }
      html += '<div class="quick-add-sheet__info">';
      html += '<h3 class="quick-add-sheet__title">' + escapeHtml(product.title) + '</h3>';
      html += '<div class="quick-add-sheet__price" data-quick-add-price>' + buildPriceHtml(firstVariant) + '</div>';
      html += '</div></div>';

      /* Options — normalise from options_with_values or derive from variants */
      var normalisedOptions = normaliseOptions(product);

      if (normalisedOptions.length > 0 && !(normalisedOptions.length === 1 && normalisedOptions[0].name === 'Title' && normalisedOptions[0].values.length === 1)) {
        html += '<div class="quick-add-sheet__options">';

        normalisedOptions.forEach(function (option, optIndex) {
          var isColor = isColorOption(option.name);
          var firstVal = firstVariant ? firstVariant['option' + (optIndex + 1)] : option.values[0];

          html += '<fieldset class="quick-add-sheet__option">';
          html += '<legend class="quick-add-sheet__option-name">' + escapeHtml(option.name) + ': <span data-option-selected="' + optIndex + '">' + escapeHtml(firstVal) + '</span></legend>';
          html += '<div class="quick-add-sheet__option-values">';

          option.values.forEach(function (value) {
            var checked = value === firstVal;
            var labelClass = 'quick-add-sheet__option-label';
            if (isColor) labelClass += ' quick-add-sheet__swatch-label';

            html += '<label class="' + labelClass + '">';
            html += '<input type="radio" name="quick-add-option-' + optIndex + '" value="' + escapeHtml(value) + '"' + (checked ? ' checked' : '') + ' class="visually-hidden">';

            if (isColor) {
              html += '<span class="quick-add-sheet__swatch" style="background-color: ' + escapeHtml(value) + '" title="' + escapeHtml(value) + '"></span>';
            } else {
              html += '<span class="quick-add-sheet__pill">' + escapeHtml(value) + '</span>';
            }

            html += '</label>';
          });

          html += '</div></fieldset>';
        });

        html += '</div>';
      }

      /* Form */
      html += '<form class="quick-add-sheet__form" data-quick-add-form>';
      html += '<input type="hidden" name="id" value="' + (firstVariant ? firstVariant.id : '') + '" data-quick-add-variant-id>';
      html += '<input type="hidden" name="quantity" value="1">';
      html += '<button type="submit" class="btn btn--primary btn--full quick-add-sheet__submit" data-quick-add-submit' + (!firstVariant || !firstVariant.available ? ' disabled' : '') + '>';

      if (!firstVariant || !firstVariant.available) {
        html += 'Sold out';
      } else {
        html += 'Add to cart \u2014 ' + formatMoney(firstVariant.price);
      }

      html += '</button></form>';

      /* View details link */
      html += '<a href="' + escapeHtml(product.url) + '" class="quick-add-sheet__view-details">View full details</a>';

      bodyEl.innerHTML = html;

      /* Bind variant change listeners */
      var radios = bodyEl.querySelectorAll('input[type="radio"]');
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          onVariantChange(product);
        });
      });

      /* Bind form submit */
      var form = bodyEl.querySelector(SELECTORS.form);
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          submitForm(form);
        });
      }

      /* Update availability indicators for initial state */
      updateAvailabilityIndicators(product);

      announce(product.title + ' quick add loaded. Select your options.');
    }

    function renderError(handle) {
      bodyEl.innerHTML =
        '<div class="quick-add-sheet__error">' +
        '<p class="quick-add-sheet__error-message">Something went wrong loading this product. Please try again.</p>' +
        '<button class="quick-add-sheet__error-retry" data-retry-handle="' + escapeHtml(handle) + '">Try again</button>' +
        '</div>';

      var retryBtn = bodyEl.querySelector('.quick-add-sheet__error-retry');
      if (retryBtn) {
        retryBtn.addEventListener('click', function () {
          var h = retryBtn.getAttribute('data-retry-handle');
          delete productCache[h];
          openSheet(h);
        });
        retryBtn.focus();
      }

      announce('Error loading product. A retry button is available.');
    }

    /* ---------- Variant selection ---------- */

    function getSelectedOptions() {
      var options = [];
      var fieldsets = bodyEl.querySelectorAll('.quick-add-sheet__option');

      fieldsets.forEach(function (fieldset, index) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        options[index] = checked ? checked.value : undefined;
      });

      return options;
    }

    function updateAvailabilityIndicators(product) {
      var selectedOptions = getSelectedOptions();
      var options = normaliseOptions(product);

      options.forEach(function (option, optIndex) {
        var labels = bodyEl.querySelectorAll('input[name="quick-add-option-' + optIndex + '"]');

        labels.forEach(function (input) {
          var label = input.closest('.quick-add-sheet__option-label');
          if (!label) return;

          /* Check availability with current selections in other option groups */
          var testOptions = [];
          for (var i = 0; i < options.length; i++) {
            if (i === optIndex) {
              testOptions[i] = input.value;
            } else {
              testOptions[i] = selectedOptions[i];
            }
          }

          var available = product.variants.some(function (v) {
            var match = true;
            for (var j = 0; j < testOptions.length; j++) {
              if (testOptions[j] !== undefined) {
                if (v['option' + (j + 1)] !== testOptions[j]) {
                  match = false;
                  break;
                }
              }
            }
            return match && v.available;
          });

          if (available) {
            label.classList.remove('is-unavailable');
            input.removeAttribute('aria-disabled');
          } else {
            label.classList.add('is-unavailable');
            input.setAttribute('aria-disabled', 'true');
          }
        });
      });
    }

    function onVariantChange(product) {
      var selectedOptions = getSelectedOptions();
      var variant = findVariant(product, selectedOptions);

      /* Update legend text */
      selectedOptions.forEach(function (val, index) {
        var span = bodyEl.querySelector('[data-option-selected="' + index + '"]');
        if (span && val) span.textContent = val;
      });

      /* Update price */
      var priceEl = bodyEl.querySelector(SELECTORS.priceEl);
      if (priceEl) {
        priceEl.innerHTML = buildPriceHtml(variant);
      }

      /* Update hidden variant ID */
      var variantInput = bodyEl.querySelector(SELECTORS.variantId);
      if (variantInput) {
        variantInput.value = variant ? variant.id : '';
      }

      /* Update submit button */
      var submitBtn = bodyEl.querySelector(SELECTORS.submitBtn);
      if (submitBtn) {
        if (!variant) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Unavailable';
        } else if (!variant.available) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sold out';
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add to cart \u2014 ' + formatMoney(variant.price);
        }
      }

      /* Update product image if variant has a featured image */
      if (variant && variant.featured_image && variant.featured_image.src) {
        var img = bodyEl.querySelector('.quick-add-sheet__image');
        if (img) {
          img.src = getSizedImageUrl(variant.featured_image.src, '240x320_crop_center');
          img.alt = variant.featured_image.alt || product.title;
        }
      }

      /* Update availability indicators */
      updateAvailabilityIndicators(product);

      /* Screen reader announcement */
      if (variant) {
        if (variant.available) {
          announce(variant.title + ', ' + formatMoney(variant.price) + ', available.');
        } else {
          announce(variant.title + ', sold out.');
        }
      } else {
        announce('Selected combination is unavailable.');
      }
    }

    /* ---------- Cart submission ---------- */

    function submitForm(form) {
      var submitBtn = form.querySelector(SELECTORS.submitBtn);
      var variantInput = form.querySelector(SELECTORS.variantId);

      if (!variantInput || !variantInput.value) return;

      /* Prevent double-submit */
      if (submitBtn.hasAttribute('data-submitting')) return;
      submitBtn.setAttribute('data-submitting', '');

      var originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding\u2026';
      submitBtn.disabled = true;

      var formData = {
        items: [{
          id: parseInt(variantInput.value, 10),
          quantity: 1
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data.description || 'Could not add to cart');
            });
          }
          return res.json();
        })
        .then(function (item) {
          submitBtn.textContent = 'Added \u2713';
          announce('Item added to cart.');

          /* Long enough to register the confirmation, short enough to feel
             "quick" \u2014 the cart toast/badge carry the state after we close. */
          setTimeout(function () {
            closeSheet();

            /* Refresh cart badge + show the added-to-bag toast */
            document.dispatchEvent(new CustomEvent('cart:added', {
              bubbles: true,
              detail: { item: item, trigger: submitBtn }
            }));
          }, 900);
        })
        .catch(function (err) {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
          announce('Error: ' + err.message);
        })
        .finally(function () {
          submitBtn.removeAttribute('data-submitting');
        });
    }

    /* ---------- Opening / closing ---------- */

    function showLoading() {
      bodyEl.innerHTML = '';
      bodyEl.hidden = true;
      loadingEl.hidden = false;
    }

    function hideLoading() {
      loadingEl.hidden = true;
      bodyEl.hidden = false;
    }

    function openSheet(handle) {
      if (!handle) return;

      triggerElement = document.activeElement;
      isOpen = true;
      var token = ++requestToken;

      sheet.hidden = false;
      showLoading();

      /* Force reflow before adding class for transition */
      void sheet.offsetHeight;
      sheet.classList.add('is-open');

      document.body.classList.add('quick-add-sheet-open');

      /* Focus close button after transition */
      var closeBtn = sheet.querySelector('.quick-add-sheet__close');
      setTimeout(function () {
        if (closeBtn) closeBtn.focus();
      }, 50);

      fetchProduct(handle)
        .then(function (product) {
          /* Ignore if the shopper has since opened a different product or closed the sheet. */
          if (token !== requestToken || !isOpen) return;
          hideLoading();
          renderProduct(product);
        })
        .catch(function () {
          if (token !== requestToken || !isOpen) return;
          hideLoading();
          renderError(handle);
        });
    }

    function closeSheet() {
      if (!isOpen) return;
      isOpen = false;

      sheet.classList.remove('is-open');
      document.body.classList.remove('quick-add-sheet-open');
      currentProduct = null;

      /* Wait for transition, then hide */
      var onTransitionEnd = function () {
        sheet.hidden = true;
        bodyEl.innerHTML = '';
        panel.removeEventListener('transitionend', onTransitionEnd);

        /* Return focus to trigger */
        if (triggerElement && typeof triggerElement.focus === 'function') {
          triggerElement.focus();
        }
        triggerElement = null;
      };

      /* If reduced motion, skip transition wait */
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) {
        onTransitionEnd();
      } else {
        panel.addEventListener('transitionend', onTransitionEnd);
        /* Fallback in case transitionend doesn't fire */
        setTimeout(function () {
          if (sheet.hidden) return;
          onTransitionEnd();
        }, 500);
      }
    }

    /* ---------- Focus trap ---------- */

    function getFocusableElements() {
      return panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not(.visually-hidden), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
    }

    function trapFocus(e) {
      if (!isOpen) return;
      if (e.key !== 'Tab') return;

      var focusable = getFocusableElements();
      if (focusable.length === 0) return;

      var firstEl = focusable[0];
      var lastEl = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }

    /* ---------- Event listeners ---------- */

    /* Open trigger — delegated */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(SELECTORS.trigger);
      if (!trigger) return;

      e.preventDefault();
      var handle = trigger.getAttribute('data-product-handle');
      if (handle) openSheet(handle);
    });

    /* Close triggers — delegated within sheet */
    sheet.addEventListener('click', function (e) {
      if (e.target.closest(SELECTORS.close) || e.target.hasAttribute('data-quick-add-close')) {
        closeSheet();
      }
    });

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        closeSheet();
      }
    });

    /* Focus trap */
    document.addEventListener('keydown', trapFocus);
  })();
  } catch(e) { console.error(e); }
})();

})();
